module.exports = __webpack_public_path__ + "img/belize.90f1f22f.svg";